import React, { PropsWithChildren } from 'react';

import { theme } from '@garnish/constants';
import { HStack } from '@garnish/core';

// ─────────────────────────────────────────────────────────────────────────────

export const NavbarFloatingNavLinksList = (props: Props) => {
  const { children } = props;

  return <HStack gap={theme.spacing['4']}>{children}</HStack>;
};

// ─── Types ───────────────────────────────────────────────────────────────────

type Props = PropsWithChildren;
